import { render, staticRenderFns } from "./orderinvoice.vue?vue&type=template&id=841f7c56&scoped=true"
import script from "./orderinvoice.vue?vue&type=script&lang=js"
export * from "./orderinvoice.vue?vue&type=script&lang=js"
import style0 from "./orderinvoice.vue?vue&type=style&index=0&id=841f7c56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841f7c56",
  null
  
)

export default component.exports